import { render, staticRenderFns } from "./newAgent.vue?vue&type=template&id=12f9485a&scoped=true"
import script from "./newAgent.vue?vue&type=script&lang=js"
export * from "./newAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9485a",
  null
  
)

export default component.exports